import React, { useRef, useState } from 'react'
import ImageBuffer from '../../ImageBuffer/ImageBuffer'
import {Badge, ReadMore, SubCover, SubHeader} from '../..'
import { ArrowForwardRounded } from '@mui/icons-material'
import { hero1 } from '../../../assets'

import './about.css'

const About = () => {
    const modalNavRef                             = useRef<HTMLDivElement | null>(null);
    const [openSubMegaMenu, setOpenSubMegaMenu]   = useState<number | null>(null);
    const [toggleResult, setToggleResult]         = useState<boolean>(false);

    const handleToggleAboutMore = (index: number) => {
        // setToggleResult(true)
        setOpenSubMegaMenu(prev => (prev === index ? null : index));
    }

    const handleCloseCover = () => {
        setToggleResult(false)
        setOpenSubMegaMenu(null);
    }
   
    const closeAboutModal = (e: React.MouseEvent<HTMLElement>) => {
        if(modalNavRef.current === e.target){
            setToggleResult(false)
            setOpenSubMegaMenu(null)
        }
    }

  return (
    <>
        <div id="about" className='about-wrapper'>
            <Badge title="About Us" />
            <SubHeader title="What we do" description="" />
            <div className="about-container">
                <div className="about-main-box-image-cover">
                    <ImageBuffer className="about-main-box-image" src={hero1} alt="" />
                </div>
                <div className="about-main-box">
                    <h1 className="about-main-description">What we do?</h1>
                    <div className="about-main-gradient"></div>
                    <p className="about-main-8">Gloria's Serenity Homes, LLC is a trusted Texas-based home health agency dedicated to delivery comprehensive medical home health and therapy services that promote healing.</p>
                    <p className="about-main-4">Guided by a deep commitment to compassion, clinical excellence, and individual care, our team provides skilled nursing, physical, occupational, and speech therapy within the comfort and safety of each client's home.</p>
                    <button className="about-main-read-more-btn-cover" onClick={() => handleToggleAboutMore(1)}>
                        <span>Read more</span>
                        <ArrowForwardRounded />
                    </button>
                    <ReadMore onOpen={toggleResult} onClose={closeAboutModal} openSubMegaMenu={openSubMegaMenu} />
                </div>
            </div>
        </div>
        {openSubMegaMenu !== null && (
            //z-index: 3, others should be higher
            <SubCover handleCloseCover={handleCloseCover} />
        )}
    </>
  )
}

export default About